{
  "dateFormats": {
    "dayNumberShortDay": "{{ date, dayNumberShortDay }}",
    "longMonth": "{{ date, longMonth }}",
    "shortMonthDayYear": "{{ date, shortMonthDayYear }}",
    "time": "{{ date, time }}",
    "dayNumber": "{{ date, dayNumber }}",
    "dayShort": "{{ date, dayShort }}",
    "dayLong": "{{ date, dayLong }}",
    "dateTime": "{{ date, dateTime }}"
  },
  "Now": "Now",
  "Today": "Today",
  "Yesterday": "Yesterday",
  "datePicker": {
    "presets": {
      "yesterday": "Yesterday",
      "last7Days": "Last 7 days",
      "last14Days": "Last 14 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "last6Months": "Last 6 months",
      "last12Months": "Last 12 months"
    }
  },
  "at": "at",
  "Month": "Month",
  "Birth date": "Birth date",
  "All day": "All day",
  "Daylight Saving Time ends at {{transitionTime}} on {{dayOfWeek}}, and clocks are set back to {{adjustedTime}}.": "Daylight Saving Time ends at {{transitionTime}} on {{dayOfWeek}}, and clocks are set back to {{adjustedTime}}.",
  "Daylight Saving Time starts at {{transitionTime}} on {{dayOfWeek}}, and clocks are set forward to {{adjustedTime}}.": "Daylight Saving Time starts at {{transitionTime}} on {{dayOfWeek}}, and clocks are set forward to {{adjustedTime}}.",
  "Loading events": "Loading events",
  "Events loaded": "Events loaded",
  "Scroll left": "Scroll left",
  "Scroll right": "Scroll right",
  "moreEvents": "+ {{count}} more",
  "Step {{step}} of {{total}}": "Step {{step}} of {{total}}",
  "Remove attachment": "Remove attachment",
  "Close modal window": "Close modal window",
  "Link image": "Link image",
  "New message": "New message",
  "emptyState": {
    "description": "{{name}} will appear here when available",
    "descriptionFiltered": "Try adjusting your search or filter",
    "title": "No {{name}} yet",
    "titleFiltered": "No {{name}} found"
  },
  "table": {
    "pagination_one": "{{from}} - {{to}} from {{total}} result",
    "pagination_other": "{{from}} - {{to}} from {{total}} results"
  }
}
